import { t } from "../../utils/i18n";
import React from "react";
import AutoComplete from "../AutoComplete";

const WalletTransfer = ({
  selectedTransferType,
  submitting,
  transferTypes,
  destinationWallets,
  validationErrors,
  recipient,
  lookedUpRecipient,
  recipients,
  selectedDestinationWallet,
  handleChange,
  handleRecipientChange,
}) => (
  <div className="w-100">
    {destinationWallets.length > 0 && (
      <div className="form-group required mt-2 ">
        <label className="form-label">{t("transfers_send.common.select_crypto_wallet")}</label>
        <select
          className="form-control form-control-lg expand-select"
          required="required"
          value={selectedTransferType}
          disabled={submitting == true ? true : false}
          onChange={(e) => handleChange(e, "selectedTransferType")}
        >
          <option value="">{t("transfers_send.common.select_wallet_option")}</option>
          {transferTypes.map((transferType, i) => (
            <option key={i} value={transferType.value}>
              {transferType.label}
            </option>
          ))}
        </select>
      </div>
    )}
    {(destinationWallets.length === 0 ||
      selectedTransferType === "recipient") && (
      <div className={`form-group required recipient recipient-wrapper`}>
        <label className="form-label">{t("transfers_send.common.recipient")}</label>
        <AutoComplete
          updateRecipient={handleRecipientChange}
          placeholder={t("transfers_send.common.recipient_placeholder")}
          className={`form-control`}
          disabled={submitting == true ? true : false}
          suggestions={recipients}
          lookedUpRecipient={lookedUpRecipient}
          userInput={recipient}
          validationError={validationErrors?.recipientError}
        />
        {validationErrors?.recipientError && (
          <small className="error text-danger">
            {validationErrors.recipientError}
          </small>
        )}
        <small id="amountHelpBlock" className="form-text text-muted">
          {t("transfers_send.common.recipient_help")}
        </small>
      </div>
    )}
    {selectedTransferType === "my-wallet" && (
      <div className="form-group required destination_wallet">
        <label className="form-label">{t("transfers_send.common.destination_wallet")}</label>
        <select
          className="form-control form-control-lg expand-select"
          value={selectedDestinationWallet}
          onChange={(e) => this.handleChange(e, "selectedDestinationWallet")}
        >
          {destinationWallets.map((wallet, i) => (
            <option key={i} value={wallet[1]}>
              {wallet[0]}
            </option>
          ))}
        </select>
      </div>
    )}
  </div>
);

export default WalletTransfer;
